import { HEADERMENU_PATH } from '../../routes/RoutesURL';

export const showUnAuthenticated = (pathname: string) => {
    if (
        pathname === HEADERMENU_PATH.login ||
        pathname === HEADERMENU_PATH.accountActivation ||
        pathname === HEADERMENU_PATH.signUp ||
        pathname === HEADERMENU_PATH.signUpSuccess ||
        pathname === HEADERMENU_PATH.resendActivateEmail ||
        pathname === HEADERMENU_PATH.forgotPassword ||
        pathname === HEADERMENU_PATH.forgotPasswordMessage ||
        pathname === HEADERMENU_PATH.resetPassword
    ) {
        return true;
    }
    return false;
};

export const showOnlyLogout = (pathname: string) => {
    if (pathname === HEADERMENU_PATH.onboarding) {
        return true;
    }
    return false;
};
